document.addEventListener('DOMContentLoaded', function() {
  var menuButton = document.querySelector('.js-drawer-open-left-link');
  if (menuButton) {
    menuButton.addEventListener('click', function() {
      // 切換 active 類別，並根據狀態隱藏/顯示不同的圖示
      menuButton.classList.toggle('active');
      // 取得 SVG 圖示
      var hamburgerIcon = menuButton.querySelector('.icon-hamburger');
      var closeIcon = menuButton.querySelector('.icon-close');
      if (menuButton.classList.contains('active')) {
        // 開啟時隱藏漢堡圖示、顯示叉叉
        if (hamburgerIcon) hamburgerIcon.style.display = 'none';
        if (closeIcon) closeIcon.style.display = 'block';
      } else {
        // 關閉時顯示漢堡圖示、隱藏叉叉
        if (hamburgerIcon) hamburgerIcon.style.display = 'block';
        if (closeIcon) closeIcon.style.display = 'none';
      }
    });
  }
});
